export enum ELocalStorageKey {
  TOKEN_ACTIVE_KEY = 'MCE:ACTIVE_KEY',
  TOKEN_MAIN = 'MCE:MAIN',
  TOKEN_SEND_PACKAGE = 'MCE:SEND_PACKAGE',
  TOKEN_VALUE = 'MCE:VALUE',
  TOKEN_PREVIOUS_VALUE = 'MCE:PREV_VALUE',
  ERROR_KEY = 'MCE:ERROR',
  I18N = 'i18n',
  TURN_ON_3G_VISITED = 'turnOn3GVisited',
  SKIP_HOME = 'skipHome'
}
